import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import RFQStepController from 'store/pages/initiate-quote/altus/step-controllers/rfqStepController';
import { ALTUS_INITIATE_QUOTE_RFQ_FORM_ID } from '../constants';
import { IMFormStyled } from './styles';

interface Props {
  rfqStepController: RFQStepController;
}

const AltusRFQStep: React.FC<Props> = observer(({ rfqStepController }) => {
  return (
    <IMFormStyled id={ALTUS_INITIATE_QUOTE_RFQ_FORM_ID} formController={rfqStepController.form}>
      <SectionTitle
        title="RFQ Information"
        subtitle="Provide the additional information required for your RFQ proposal"
      />
      <IMInputText label="Response Due Date" name="responseDueDate" size="full" htmlType="date" />
    </IMFormStyled>
  );
});

export default AltusRFQStep;
